import React, {useRef} from 'react';
import t from 'babel-plugin-yate/macro';

import {Block} from '../../components/uiElem';
import Button from '../../components/Button';
import {Products} from '../Products';
import ReceivedDetailsForm from './ReceivedDetailsForm';
import {RefinancingPromo} from '../RefinancingPromo';

import {ANAF_CODE} from '../../config/employmentStatuses';
import errorFocus from '../../lib/errorFocus';

function Step1(props) {
  const formRef = useRef();
  const {data, patchHandler, uuid} = props;
  const isConsumerFinance = data.type === 4;
  const isPersonalNeeds = data.type === 5;

  return (
    <>
      <div className="lg:flex -ml-10">
        <div className="lg:w-full pl-10">
          <ReceivedDetailsForm
            initialValues={{
              ...data,
              customer: {
                professional_status: Boolean(
                  data?.customer?.professional_status.length,
                )
                  ? data.customer.professional_status
                  : [
                      /**
                       * if the 'professional_status' is not received from Altex or MediaGalaxy,
                       * 'Employee with ANAF' is checked by default
                       * */
                      {code: ANAF_CODE},
                    ],
                ...data?.customer,
              },
            }}
            handleAction={patchHandler}
            disabled={false}
            uuid={uuid}
            formRef={formRef}
          />
        </div>

        {isConsumerFinance && (
          <div className="lg:w-1/3 pl-10 flex-shrink-0">
            <Block
              heading={t`Order summary`}
              description={
                data?.is_refinance
                  ? t`Refinantare card de credit`
                  : t`Shopping cart`
              }
              descriptionClassName="saturn"
              className="bg-purple-lightest text-pink">
              <div className="px-4 pb-5 pt-8">
                <Products
                  products={data?.products ?? []}
                  total={data?.detail?.loan_amount ?? 0}
                />
              </div>
            </Block>
          </div>
        )}

        {isPersonalNeeds && (
          <div className="lg:w-1/3 pl-10 flex-shrink-0">
            <Block className="bg-purple-light text-white">
              <div className="px-4 pb-5 pt-8">
                <RefinancingPromo />
              </div>
            </Block>
          </div>
        )}
      </div>

      <div className="py-6 flex justify-between">
        <div className="w-64 mx-auto sm:mr-0">
          <Button
            fullWidth
            color="orange"
            border={false}
            title={t`Continue`}
            onClick={() => {
              errorFocus(formRef.current);

              formRef.current.dispatchEvent(
                new Event(
                  'submit',
                  /**
                   * https://github.com/facebook/react/issues/12639
                   */
                  {cancelable: true},
                ),
              );
            }}
          />
        </div>
      </div>
    </>
  );
}

export default Step1;
